import { z } from 'zod';

// NPS Feedback Form Schema
export const npsFeedbackFormSchema = z.object({
  likelyToRecommendRating: z.enum([
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '10',
  ]),
  likelyToRecommendReasons: z.string().optional(),
  overallExperienceRating: z.enum(['1', '2', '3', '4', '5']),
  overallExperienceSuggestions: z.string().optional(),
  easeOfDoingBusinessRating: z.enum([
    'Extremely Difficult',
    'Very Difficult',
    'Fairly Difficult',
    'Neither Easy or Difficult',
    'Fairly Easy',
    'Very Easy',
    'Extremely Easy',
  ]),
  easeOfDoingBusinessSuggestions: z.string().optional(),
  brandOfChoiceRating: z.enum(['1', '2', '3', '4', '5']),
  brandOfChoiceReasons: z.string().optional(),
  useInMarketing: z.boolean().default(false),
});

export type NpsFeedbackFormSchema = z.infer<typeof npsFeedbackFormSchema>;
